/* P.N.E. V6.3: open the complete Brand Film as a user-controlled video.
   The muted looping background and the full-length film are separate players. */
(() => {
  const mounted = new WeakSet();
  function boot(scope = document) {
    scope.querySelectorAll('[data-pne-v63-hero]').forEach(root => {
      if (mounted.has(root)) return;
      mounted.add(root);
      const dialog = root.querySelector('[data-pne-v63-film-dialog]');
      const openButton = root.querySelector('[data-pne-v63-open-film]');
      const closeButton = root.querySelector('[data-pne-v63-close-film]');
      const player = dialog?.querySelector('.pne-v63-film-dialog__player');
      const ambient = root.querySelector('[data-pne-deferred-hero-video]');
      if (!dialog || !player || !openButton) return;
      const close = () => { player.pause(); if (dialog.open) dialog.close(); };
      const resume = () => { if (ambient && ambient.readyState > 0 && matchMedia('(min-width: 750px)').matches) ambient.play().catch(() => {}); };
      openButton.addEventListener('click', () => {
        const sources = [...player.querySelectorAll('source[data-src]')];
        if (sources.length) {
          sources.forEach(source => { source.src = source.dataset.src; source.removeAttribute('data-src'); });
          player.load();
        }
        ambient?.pause();
        player.currentTime = 0;
        player.muted = false;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else { dialog.setAttribute('open', ''); }
        const play = player.play();
        if (play?.catch) play.catch(() => {});
      });
      closeButton?.addEventListener('click', close);
      dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
      dialog.addEventListener('close', () => { player.pause(); resume(); });
      root.addEventListener('shopify:section:unload', close);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
